var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDelivery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.58,22a6.85,6.85,0,0,0-5.78-3.17H63.55V16.46a6.06,6.06,0,0,0-6.06-6.06H5.72A4.66,4.66,0,0,0,1,14.48a4.53,4.53,0,0,0,4.51,5H25.27A4.42,4.42,0,0,1,29.38,22a4.56,4.56,0,0,1-4.12,6.47H5.72A4.66,4.66,0,0,0,1,32.59a4.53,4.53,0,0,0,4.51,5h9.39a4.66,4.66,0,0,1,4.7,4.08,4.53,4.53,0,0,1-4.51,5H6a4.66,4.66,0,0,0-4.7,4.08,4.53,4.53,0,0,0,4.51,5H9.37V73.35a6.45,6.45,0,0,0,6.45,6.45h4.4a14.84,14.84,0,0,0,14.09,9.8,15.12,15.12,0,0,0,14.08-9.8H60.64a14.85,14.85,0,0,0,14.09,9.8,15.12,15.12,0,0,0,14.08-9.8h3.74A6.45,6.45,0,0,0,99,73.35V50.8a10.28,10.28,0,0,0-1.61-5.52ZM34.31,80.2a5.64,5.64,0,0,1-5.63-5.62A5.72,5.72,0,0,1,34.31,69a5.63,5.63,0,1,1,0,11.25Zm40.43,0a5.68,5.68,0,0,1-5.66-5.66,5.75,5.75,0,0,1,5.66-5.66,5.68,5.68,0,0,1,5.66,5.66A5.75,5.75,0,0,1,74.73,80.24ZM85.58,47.43H65.63a1.25,1.25,0,0,1-1.25-1.25V29.73a1.25,1.25,0,0,1,1.25-1.25h9.48a1.24,1.24,0,0,1,1.05.58L86.63,45.52A1.25,1.25,0,0,1,85.58,47.43Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelivery);
export default __webpack_public_path__ + "static/media/icon-delivery.519717d1.svg";
export { ForwardRef as ReactComponent };